export class FiltroDetalheSorteioConsumidor {

    consumidorId: number;
    sorteioId: number;

    constructor(consumidorId: number, sorteioId : number) {
        this.consumidorId = consumidorId;
        this.sorteioId = sorteioId;
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/filter/filtro-detalhes-sorteio-consumidor.ts